const initialState = {
  CodePanel: {
    content: '',
    updateLocalContent: false,
    insertedOperationCode: '',
    insertLocation: '',
  },
  NavigationBar: {
    darkToggle: false,
  },
  OperationsMenu: {
    embeddingType: 'Dashboard',
  },
  PreviewPanel: {
    reload: false,
  },
  ExampleGallery: {
    isOpen: false,
    dossierUrl: '',
    exampleGroupName: '',
    exampleName: '',
    exampleId: '',
    exampleDesc: '',
    image: '',
  },
  EventPanel: {
    eventContent: '',
  },
  EnvironmentSetting: {
    isOpen: false,
    customUrl: '',
    username: '',
    password: '',
    contentGroup: '',
  },
};
export default initialState;
